import { forwardRef, Ref } from 'react'
import styled from 'styled-components'

export const Wrapper = styled.select<{ 
  onChange: any,
  $w?: string, $h?: string,
  $ml?: string, $mr?: string, $mt?: string, $mb?: string 
  $pl?: string, $pr?: string, $pt?: string, $pb?: string 
  $b?: string, $bRad?: string 

}>`
  ${props => props.$w ? 'width: ' + props.$w + '; ' : ''}
  ${props => props.$h ? 'height: ' + props.$h + '; ' : ''}
  ${props => props.$ml ? 'margin-left: ' + props.$ml + '; ' : ''}
  ${props => props.$mr ? 'margin-right: ' + props.$mr + '; ' : ''}
  ${props => props.$mt ? 'margin-top: ' + props.$mt + '; ' : ''}
  ${props => props.$mb ? 'margin-bottom: ' + props.$mb + '; ' : ''}
  ${props => props.$pl ? 'padding-left: ' + props.$pl + '; ' : ''}
  ${props => props.$pr ? 'padding-right: ' + props.$pr + '; ' : ''}
  ${props => props.$pt ? 'padding-top: ' + props.$pt + '; ' : ''}
  ${props => props.$pb ? 'padding-bottom: ' + props.$pb + '; ' : ''}
  ${props => props.$b ? 'border: ' + props.$b + '; ' : ''}
  ${props => props.$bRad ? 'border-radius: ' + props.$bRad + '; ' : ''}

  background: var(--backgroundColor);
`


interface SelectorProps<T extends HTMLSelectElement>
  extends React.HTMLProps<T> {
    w?: string, h?: string,
    ml?: string, mr?: string, mt?: string, mb?: string
    pl?: string, pr?: string, pt?: string, pb?: string
    b?: string, bRad?: string, onChange: any
  
  }
export const Selector = forwardRef(<T extends HTMLSelectElement>(props: SelectorProps<T>, ref:Ref<HTMLSelectElement>) => {

  return <Wrapper {...ref} onChange={props.onChange}
    $w={props.w} $h={props.h} 
    $ml={props.ml} $mr={props.mr} $mt={props.mt} $mb={props.mb} 
    $pl={props.pl} $pr={props.pr} $pt={props.pt} $pb={props.pb} $b={props.b} $bRad={props.bRad} >
    {props.children}
  </Wrapper>
    
  
})